export default __webpack_public_path__ + "static/media/medical Care.ad3f2280.svg";